export const colors = {
  started: '#007CB0',
  finished: '#00B400',
  unstarted: '#D8D8D8',
  gray:'#595959',
  black: '#222',
  trueBlack: '#000',
  white: '#fff',
  white50: 'rgba(255, 255, 255, .5)',
  text: '#333D47',
  dropdownText: '#2e373c',
  secondary: '#ffd200',
  primary: '#007cb0',
  whiteGray: '#f9f9f9',
  whiteRipple: 'rgba(255,255,255,0.4)',
  dirtyWhite: '#f2f2f2',
  stackColors: ['#36474f', '#546e7a','#e5e5e5'],
  stackColorsText: ['#ffffff', '#ffffff', '#333333'],
  donutColors: ['#36474f', '#546e7a', '#007cb0', '#2bb3d0', '#e5e5e5'],
  donutPressureColors: ['#007cb0', '#e5e5e5'],
  gainLossColors: ['#00b400', '#d0021b', '#a1a1a1'],
  gainLossFillColors: ['#f24444', '#7ed321'],
  preStackColors: ['#36474f', '#007cb0'],
  tiers: ['#e20000', '#ff8000', '#7ed321', '#cdcdcd'],
  dark: '#2d3741',
  darkTwo: '#283037',
  dimmed: '#94989d',
  border: '#dedede',
  lightGrey: '#d0d1d4',
  greyText: '#4c4c4c',
  lightGreyText: '#8f8f8f',
  grey: '#b6b9bc',
  greyBorder: '#e7e5e5',
  pinkishGrey: '#c1c1c1',
  whiteSelected: '#eaeaea',
  greyTextDesc: '#414141',
  redArrow: '#d0021b',
  pumpkinOrange: '#ff8000',
  greyTextPosition: '#7e868c',
  backgroundGrey: '#eee',
  fadedGreyBorder: '#515d65',
  hardFadedGreyBorder: '#f4f4f4',
  hardFadedBorderPlayers: '#ebeaeb',
  iconGrey: '#d8d8d8',
  basicGrey: '#ececec',
  groupedBars: ['#36474f', '#88a5b1'],
  tableHeader: '#f8f8f8',
  tableHeaderText: '#7e868c',
  tableHover: '#faf9fa',
  charcoalGreyTwo: '#36474f',
  appleGreen: '#7ed321',
  trueGreen: '#00b400',
  selectLightBlue: '#f7fbfc',
  darkishBlue: '#054998',
  whiteTwo: '#e4e4e4',
  googleBlue: '#4285F4',
  pinkishRed: '#ed1c24',
  searchGreyBg: '#fcfcfc',
  whiteThree: '#d8d8d8',
  disabledFilter: '#8f98a3',
  whiteFour: '#fcfcfc',
  darkGrassGreen: '#417505',
  peacockBlue: '#00658b',
  paleGrey: '#e4e3e4',
  tableColumnBackground: 'rgba(248, 248, 248, 0.3)',
  dustyOrange: '#ea8d2f',
  tomato: '#f24444',
  scarlet: '#d0021b',
  selectiveYellow: '#fbb600',
  doveGray: '#666',
  fadedGreyText: '#7f7f7f',
  paleSkyBlue: '#d8dfe4',
  dullGreen: '#86a465',
  veryLightBlue: '#e5ecf0',
  lightGreyBlue: '#aabdcb',
  iceBlue: '#edf0f2',
  grayTooltip: 'rgba(156, 164, 171)',
  calendarLightBlue: '#007ABA',
  calendarDarkBlue: '#0A6F9A',
  calendarDayBack: '#ecf0f3',
  calendarTileItemBorder: '#d9dee1',
  calendarfadedGrey: '#57636F'
}as const;
